import React from 'react';

import { Dialog } from '@buildoutinc/blueprint-react/ui/Dialog';

import { Button } from 'components/ui/button';

import type { PendingAction, ScheduledEmail } from './types';

interface Props {
  pendingAction: PendingAction | null;
  scheduledEmails: ScheduledEmail[];
  onConfirm: () => void;
  onClose: () => void;
}

export function ScheduledEmailsDialog({ pendingAction, scheduledEmails, onConfirm, onClose }: Props) {
  return (
    <Dialog open={pendingAction != null} onClose={onClose}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>{pendingAction?.actionLabel} Email Provider</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p>
            This will cause the following{' '}
            {scheduledEmails.length === 1 ? 'scheduled email' : `${scheduledEmails.length} scheduled emails`} to be
            moved to draft:
          </p>
          <div className="email-blasts">
            {scheduledEmails.map(scheduledEmail => (
              <div className="mt-2" key={`${scheduledEmail.name}-${scheduledEmail.link}`}>
                <a href={scheduledEmail.link} rel="noreferrer" target="_blank">{scheduledEmail.name}</a>
              </div>
            ))}
          </div>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Cancel>Cancel</Dialog.Cancel>
          <Button
            label={`${pendingAction?.actionLabel} Email Provider`}
            variant="destructive"
            onClick={onConfirm}
          />
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
